export const iconFontAwesomeBuildingsTowerObservation = (
	<i className="fa-solid fa-tower-observation"></i>
);
